module.exports = __webpack_public_path__ + "media/src/application/media/help_2-345057eec05b46f239ebba737a8112ed.webp";